import * as React from 'react'
import { ConnectedRouter } from 'connected-react-router'
import RoutesWrapper from '../common/Routes/RoutesWrapper'
import './Root.scss'
import OfflineSnackbarWrapper from '../components/OfflineSnackbar/OfflineSnackbarWrapper'

export interface IRootProps {
  history: any
}

export class Root extends React.Component<IRootProps> {
  render() {
    const { history } = this.props

    return (
      <ConnectedRouter history={history}>
        <OfflineSnackbarWrapper />
        <RoutesWrapper />
      </ConnectedRouter>
    )
  }
}
